// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import isApiError from "@insite/client-framework/Common/isApiError";
import {
    ApiParameter,
    get,
    HasPagingParameters,
    patch,
    ServiceResult,
} from "@insite/client-framework/Services/ApiService";

export interface GetManagementGroupOptionsApiParameter extends ApiParameter, HasPagingParameters {
    name: string;
    details: ManagementGroupOptionsModel;
}

export interface GetManagementGroupDetailsApiParameter extends ApiParameter, HasPagingParameters {
    name?: string;
}

export interface ManagementGroupOptionsModel {
    limitSearchCatalog: boolean;
    minimumOrderAmount: number;
    showInvoicesOnline: boolean;
}

const managementGroupsUrl = "/api/guest/managementgroups";

export async function getAllManagementGroupOptions(): Promise<ServiceResult<string[]>> {
    try {
        const allManagementGroups = await get<string[]>(managementGroupsUrl);

        return {
            successful: true,
            result: allManagementGroups,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

export async function getManagementGroupDetails(
    parameter: GetManagementGroupDetailsApiParameter,
): Promise<ServiceResult<ManagementGroupOptionsModel>> {
    try {
        const managementGroup = await get<ManagementGroupOptionsModel>(`${managementGroupsUrl}/${parameter.name}`);

        return {
            successful: true,
            result: managementGroup,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

export async function updateManagementGroupDetails(
    parameter: GetManagementGroupOptionsApiParameter,
): Promise<ServiceResult<any>> {
    try {
        const updateManagementGroupResult = await patch<any>(
            `${managementGroupsUrl}/${parameter.name}`,
            parameter.details,
        );
        return {
            successful: true,
            result: updateManagementGroupResult,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
